import CompanyProfileViewComponent from "../components/CompanyProfileView";
import useCompanyProfileView from "../hooks/useCompanyProfileView";

const CompanyProfileView = (props) => {
  const companyProfileViewProps = useCompanyProfileView(props);
  return <CompanyProfileViewComponent {...companyProfileViewProps} />;
};

export default CompanyProfileView;
